export default __webpack_public_path__ + "static/media/purple-edit-pencil.32551a2c.svg";